import { useContext, useRef } from 'react';
import useSpeechRecService from './useSpeechRec';
import VocalInterfaceContext from '../context/VocalInterfaceContext';

const useAudioRecorder = () => {
  const { transcribeAudio } = useSpeechRecService();
  const transcriptionRef = useRef<string | null>(null);
  const { setCurrentText } = useContext(VocalInterfaceContext);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      let mediaRecorderInstance = new MediaRecorder(stream);
      const audioChunks: Blob[] = [];

      mediaRecorderInstance.addEventListener('dataavailable', (event) => {
        audioChunks.push(event.data);
      });

      mediaRecorderInstance.addEventListener('stop', async () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

        const reader = new FileReader();
        reader.onloadend = async () => {
          const arrayBuffer: ArrayBuffer = reader.result as ArrayBuffer;
          const audioContext = new AudioContext();
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

          const linear16Array = convertToLinear16(audioBuffer);
          const base64String = arrayBufferToBase64(linear16Array);

          // Chamando a API do Google Cloud Speech-to-Text
          const res = await transcribeAudio(base64String);
          
          if (res && res.results) {
            transcriptionRef.current = res.results[0].alternatives[0].transcript;
            handleVoiceCommand(transcriptionRef.current);
          } else {
            handleNoTranscription();
          }
        };

        reader.readAsArrayBuffer(audioBlob);
      });

      mediaRecorderInstance.start();

      setTimeout(() => {
        mediaRecorderInstance.stop();
        stream.getTracks().forEach((track) => track.stop());
      }, 3000);
    } catch (error) {
      console.error('Erro ao acessar o dispositivo de áudio:', error);
    }
  };

  
  const convertToLinear16 = (audioBuffer: AudioBuffer) => {
    const numberOfChannels = audioBuffer.numberOfChannels;
    const samples = audioBuffer.length;
    const buffer = new ArrayBuffer(samples * numberOfChannels * 2);
    const view = new DataView(buffer);
    let offset = 0;

    for (let sample = 0; sample < samples; sample++) {
      for (let channel = 0; channel < numberOfChannels; channel++) {
        const value = Math.max(
          -1,
          Math.min(1, audioBuffer.getChannelData(channel)[sample])
        );
        view.setInt16(
          offset,
          value < 0 ? value * 0x8000 : value * 0x7fff,
          true
        );
        offset += 2;
      }
    }
    return buffer;
  };
  
  const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };
  
  const handleVoiceCommand = (text: any) => {
    const processedText = postProcessTranscription(text);
    setCurrentText(processedText);
  };

  const handleNoTranscription = () => {
    console.log('nenhum comando');
    setCurrentText('nenhum comando');
  };

  const postProcessTranscription = (text: string) => {
    // Replace numerals with words
    text = text.replace(/\b4\b/g, 'quatro');
  
    // Correct capitalization for 'Queijos'
    text = text.replace(/ 4 Queijos\b/g, ' quatro queijos');
  
    return text.toLowerCase();
  };

  return {
    startRecording,
    transcriptionRef,
  };
};

export default useAudioRecorder;
